import * as Apollo from '@apollo/client';
import type { DocumentNode } from 'graphql';

import type * as Types from '../../types/generated';

const defaultOptions = {} as const;
export type GetCandidateDetailsQueryVariables = Types.Exact<
  Record<string, never>
>;

export type GetCandidateDetailsQuery = {
  viewer?: {
    id: number;
    emailAddress: any;
    trackingId: string;
    personalDetails: { firstName?: string | null };
    identity: { actor?: { id: string } | null };
    profileVisibility2?:
      | { id: string }
      | { id: string }
      | { id: string }
      | { id: string }
      | null;
  } | null;
};

export const GetCandidateDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCandidateDetails' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'personalDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'emailAddress' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'actor' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'profileVisibility2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetCandidateDetailsQuery__
 *
 * To run a query within a React component, call `useGetCandidateDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCandidateDetailsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCandidateDetailsQuery,
    GetCandidateDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCandidateDetailsQuery,
    GetCandidateDetailsQueryVariables
  >(GetCandidateDetailsDocument, options);
}
export function useGetCandidateDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCandidateDetailsQuery,
    GetCandidateDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCandidateDetailsQuery,
    GetCandidateDetailsQueryVariables
  >(GetCandidateDetailsDocument, options);
}
export function useGetCandidateDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCandidateDetailsQuery,
        GetCandidateDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCandidateDetailsQuery,
    GetCandidateDetailsQueryVariables
  >(GetCandidateDetailsDocument, options);
}
export type GetCandidateDetailsQueryHookResult = ReturnType<
  typeof useGetCandidateDetailsQuery
>;
export type GetCandidateDetailsLazyQueryHookResult = ReturnType<
  typeof useGetCandidateDetailsLazyQuery
>;
export type GetCandidateDetailsSuspenseQueryHookResult = ReturnType<
  typeof useGetCandidateDetailsSuspenseQuery
>;
export type GetCandidateDetailsQueryResult = Apollo.QueryResult<
  GetCandidateDetailsQuery,
  GetCandidateDetailsQueryVariables
>;
